import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/home";
import OurProduct from "./components/ourProduct";
import CareersPage from "./components/careers";

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Routes>
            {/* Default Route */}
            <Route path="/" element={<HomePage />} />
            <Route path="/OurProduct" element={<OurProduct />} />
            <Route path="/Careers" element={<CareersPage />} />
          </Routes>
        </div>
      </Router>
    );
  }
}

export default App;
